export const BOARD_URL = 'https://feedback.linkie.bio';
export const SDK_URL = 'https://cdn.nolt.io/widgets.js';
